import { getWindow } from "@faire/web/common/globals/getWindow";

export const recordRouteHistoryForE2E = (path?: string) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const window = getWindow();
  if (window) {
    // Don't record in server side or non-E2E
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (window.isE2E) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (!window.faire.__E2ERouteHistory__) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.faire.__E2ERouteHistory__ = [window.location.pathname];
      }
      if (path) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.faire.__E2ERouteHistory__.push(path);
      }
    }
  }
};
